<template>

  <div class="servers" v-if="device_servers.length > 0">
    <div class="header_servers">
      <p class="title">{{ translate("server.list_of") }}</p>

      <span
          v-if="$store.getters.getPermissions.permissionGod === true"
          @click="servers_show()"
          class="pointer switch"
      >
        <span class="mdi mdi-filter" />
        {{ translate("server.not_" + srv_show) }}
      </span>

      <div></div>
    </div>
    <div class="form-group--wrap response_table">
      <table>
        <thead>
        <tr class="table_ip_tr">
          <th scope="col">
            {{ translate("server.one") }}
          </th>
          <th scope="col">
            {{ translate("server.port") }}
          </th>
          <th scope="col">IP</th>
          <th scope="col">Instance Name</th>
          <th scope="col">Proxy Status</th>
          <th scope="col">ifaces</th>
          <th scope="col">Date</th>
        </tr>
        </thead>
        <tbody>
        <tr
            v-for="(server, key) in server_list"
            :key="key"
            class="table_ip_tr server_item"
            :class="network_settings?.default_route === server.channel ? 'default' : ''"
        >
          <td @dblclick="copy(server.ip)">
            <router-link
                :to="'/server/' + server.server_id"
                class="link"
                v-if="$store.getters.getPermissions.permissionGod === true"
            >
              {{ server.name }}({{ server.ip }})
            </router-link>
            <p v-else>
              {{ server.name }}({{ server.ip }})
            </p>
          </td>
          <td @dblclick="copy(server.port)">
            {{ server.port }}
          </td>
          <td @dblclick="copy(server.device_ip)">
            {{ server.device_ip }}
            <span
                v-if="$store.getters.getPermissions.permissionGod === true"
                class="mdi mdi-content-copy pointer"
                @click="copy(server.device_ip)"
            />
          </td>
          <td @dblclick="server.instance_name ? copy(server.instance_name) : ''">
            {{ server.instance_name ? server.instance_name : "" }}
          </td>
          <td @dblclick="copy(proxy_status(server.proxy))">
            {{ proxy_status(server.proxy) }}
          </td>
          <td @dblclick="copy(server.ts)" :class="check_modems(server)">
            {{ server.ifaces }}
          </td>
          <td @dblclick="copy(server.ts)">
            {{ server.ts }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

export default {
  name: "ServerList",
  props: {
    device_servers: Array,
    network_settings: [Array, Object]
  },

  data(){
    return{
      srv_show: "IPv4"
    }
  },


  computed: {
    channels(){
      return this.network_settings.channels ? this.network_settings.channels : {}
    },
    server_list(){
      let server_list = this.device_servers.map(server => {
        return {
          ...server,
          type: this.getIpVersion(server.device_ip),
          ifaces: this.getIfaceList(server.ip),
          channel: this.getChannel(server.ip)
        }
      })

      return server_list.filter(server => {
        if (this.srv_show === "IPv4"){
          if (server.type !== "IPv6") return server
        } else {
          return server
        }
      })
    }
  },
  methods:{
    check_modems(server){
      return server.ifaces?.split(',').length !== this.network_settings.modems?.length ? 'not_full' : ''
    },
    getChannel(server_ip){
      let channel_name = ""
      if (Object.keys(this.channels).length ===  0) return ""
      Object.keys(this.channels).forEach(channel => {
        if (this.channels[channel].ips.indexOf(server_ip) > -1){
          channel_name = channel
        }
      })
      return channel_name
    },
    getIfaceList(server_ip){
      let ifaces = []
      if (Object.keys(this.channels).length ===  0) return ""
      Object.keys(this.channels).forEach(channel => {
        if (this.channels[channel].ips.indexOf(server_ip) > -1){
          ifaces = this.channels[channel].iface
        }
      })
      let string = ""
      ifaces.forEach(iface => {
        string += iface
        if (ifaces[ifaces.length - 1] !== iface) string += ', '
      })
      return string
    },
    getIpVersion(ip) {
      const ipv4 = /^(25[0-5]|2[0-4]\d|1\d{2}|[0-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[0-9]?\d)){3}$/;

      if (ipv4.test(ip)) {
        return 'IPv4';
      }
      if (ip.indexOf(':') !== -1) {
        return 'IPv6';
      }

      return 'unknown';
    },

    copy(item) {
      this.copy_to_clipboard(item);
      this.global_notify("info", this.translate("clipboard.value_save_buffer"));
    },

    proxy_status(status) {
      switch (status) {
        case null:
          return "No Proxy";
        case 0:
          return "Offline";
        case 1:
          return "Online";
      }
    },

    servers_show() {
      if (this.srv_show === "all") {
        this.srv_show = "IPv4";
      } else {
        this.srv_show = "all";
      }
    },
  }

};

</script>

<style lang="scss">

.servers {
  .header_servers {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    .title {
      font-size: 12px;
      line-height: 120%;
      font-weight: bold;
      margin: 0;
    }
    .switch{
      font-size: 12px;
      line-height: 120%;
    }
  }
  .response_table {
    padding: 0;
    .server_item{
      &.default{
        background-color: #41b88330;
      }
      tr{
        color: #252422;
      }
      &:hover{
        tr{
          background-color: #f1f1f1;
        }
      }
      p{
        margin-bottom: 0;
        font-size: 10px;
      }
    }
    table {
      tr {
        background-color: white;
        .not_full{
          background-color: #f1de5460;
        }
      }
    }
  }
}

</style>
